import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from 'uuid';
import addBook from "../redux/products/thunk/addBook";
import updateBookData from "../redux/products/thunk/updateBookData";

const AddBook = () => {
  const dispatch = useDispatch();
  const {editMode} = useSelector((state) => state.book);

  

  const [name, setName] = useState("");
  const [author, setAuthor] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [rating, setRating] = useState(0);
  const [price, setPrice] = useState(0);
  const [featured, setFeatured] = useState(false);

 useEffect(()=> {
    if(editMode.status){
        const {name, author, thumbnail, rating, price, featured} = editMode.bookData;
        setName(name);
        setAuthor(author);
        setThumbnail(thumbnail);
        setPrice(price);
        setRating(rating);
        setFeatured(featured);
    }
 },[editMode])

 const reset = () => {
    setName("");
        setAuthor("");
        setThumbnail("");
        setPrice(0);
        setRating(0);
        setFeatured(false);
 }

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
        id: uuid(),
        name,
        author,
        thumbnail,
        rating,
        price,
        featured
    }

    if(editMode.status){
        dispatch(updateBookData({...data, id: editMode.bookData.id}))
    }else{
      dispatch(addBook(data))     
    }    
    reset()
  }
  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">{editMode.status ?"Edit Book":"Add New Book"}</h4>
        <form className="book-form" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              value={thumbnail}
              onChange={(e) => setThumbnail(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                name="price"
                value={price}
                onChange={(e) => setPrice(parseInt(e.target.value))}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                min="1"
                max="5"
                value={rating}
                onChange={(e) => setRating(parseInt(e.target.value))}
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              id="input-Bookfeatured"
              type="checkbox"
              name="featured"
              className="w-4 h-4"
              checked={featured}
              onChange={() => setFeatured(!featured)}
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              {" "}
              This is a featured book{" "}
            </label>
          </div>

          <button type="submit" className="submit" id="submit">
            {editMode.status?  "Update Book" : "Add Book"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBook;
